module.exports = __webpack_public_path__ + "static/media/header_base.c84b8e19.png";